// Request and response shapes for the owner purge (plan §4: POST /admin/purge; T37).
import { z } from 'zod';

const MAX_REASON = 500;
const MIN_MATCH = 4;
const MAX_MATCH = 2000;

export const PURGE_TASK_FIELDS = [
  'updateNotes',
  'blockedReason',
  'deferredReason',
  'percentOverrideNote',
] as const;

export type PurgeRequest =
  | {
      readonly entity: 'comment';
      readonly id: number;
      readonly field: 'body';
      readonly reason: string;
      /** The secret itself, to also clear earlier versions of an edited field. */
      readonly match?: string;
    }
  | {
      readonly entity: 'evidence_record';
      readonly id: number;
      readonly field: 'note';
      readonly reason: string;
      /** The secret itself, to also clear earlier versions of an edited field. */
      readonly match?: string;
    }
  | {
      readonly entity: 'task';
      readonly id: string;
      readonly field: (typeof PURGE_TASK_FIELDS)[number];
      readonly reason: string;
      /** The secret itself, to also clear earlier versions of an edited field. */
      readonly match?: string;
    };

export const PURGE_REASON_MAX = MAX_REASON;
export const PURGE_MATCH_MIN = MIN_MATCH;
export const PURGE_MATCH_MAX = MAX_MATCH;

export const purgeResultSchema = z.object({
  entity: z.enum(['comment', 'evidence_record', 'task']),
  id: z.union([z.number().int().positive(), z.string()]),
  field: z.string(),
  dryRun: z.boolean(),
  replacement: z.string(),
  rowReplaced: z.boolean().optional(),
  eventIds: z.array(z.number().int().positive()),
  freezeIds: z.array(z.number().int().positive()).optional(),
  tombstoneEventId: z.number().int().positive().nullable(),
});
export type PurgeResult = z.infer<typeof purgeResultSchema>;
